/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-this-in-sfc */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable max-classes-per-file */
import ReactQuill, { Quill } from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './reactQuill.css';
import uniqueId from 'react-html-id';
import { Component } from 'react';
import { Dialog, DialogContent, DialogTitle } from '@material-ui/core';
import debounce from 'lodash/debounce';
import { NotificationsContext } from 'src/providers/notificationsProvider';
import { attachImageUploads } from './imageUpload';
import Modal from '../Modal/Modal';
import CButton from '../Button';
import Loader from '../Loader/Loader';

const BlockEmbed = Quill.import('blots/block/embed');

class DividerBlot extends BlockEmbed {}
DividerBlot.blotName = 'divider';
DividerBlot.tagName = 'hr';
DividerBlot.className = 'divider-blot';

class CustomWhiteSpace extends BlockEmbed {
  static create(text) {
    const node = super.create();
    node.setAttribute(
      'style',
      'background-color: white; padding: 24px 20px; color: black; width: 100%; border-radius: 32px'
    );
    node.innerText = text;
    return node;
  }

  static value(node) {
    return node.childNodes[0].textContent;
  }
}
CustomWhiteSpace.blotName = 'customWhiteSpace';
CustomWhiteSpace.tagName = 'div';
CustomWhiteSpace.className = 'whiteSpace';
Quill.register(CustomWhiteSpace);

const InlineEmbed = Quill.import('blots/embed');

class ButtonBlot extends InlineEmbed {
  static create(value) {
    const node = super.create();
    node.setAttribute('href', value.url || '#');
    node.setAttribute('data-label', value.label || '');
    node.setAttribute('data-position', value.position || 'left');
    node.setAttribute('contenteditable', 'false');
    node.textContent = value.label || '';
    return node;
  }

  static value(node) {
    return {
      label: node.getAttribute('data-label') || node.textContent,
      position: node.getAttribute('data-position') || 'left',
      url: node.getAttribute('href')
    };
  }
}
ButtonBlot.blotName = 'cmsButton';
ButtonBlot.tagName = 'a';
ButtonBlot.className = 'cms-button';
Quill.register(ButtonBlot);

class ImageBlot extends BlockEmbed {
  static create(value) {
    const node = super.create();
    node.setAttribute('alt', value.alt);
    node.setAttribute('src', value.url);
    return node;
  }

  static value(node) {
    return {
      alt: node.getAttribute('alt'),
      url: node.getAttribute('src')
    };
  }
}
ImageBlot.blotName = 'image';
ImageBlot.tagName = 'img';
ImageBlot.className = 'customImage';

const WhiteSpaceTag = () => <span>⚪</span>;
const ButtonInsertTag = () => (
  <span style={{ fontSize: '10px', fontWeight: 700, letterSpacing: '-0.5px' }}>BTN</span>
);

function test() {
  const range = this.quill.getSelection(true);
  this.quill.insertText(range.index, '\n');
  this.quill.insertEmbed(range.index + 1, 'divider', true);
  this.quill.setSelection(range.index + 2);
}

function insertWhiteSpace() {
  const range = this.quill.getSelection();

  if (range && range.length > 0) {
    const text = this.quill.getText(range.index, range.length);
    this.quill.deleteText(range.index, range.length);
    this.quill.insertEmbed(range.index, 'customWhiteSpace', text);
  }
}

const buttonModalInputStyle = {
  background: '#F0F4FF',
  border: '1px solid #CAD8FF',
  borderRadius: '8px',
  fontFamily: 'Poppins',
  fontSize: '13px',
  outline: 'none',
  padding: '12px 14px',
  width: '100%'
};

class CReactQuill extends Component {
  constructor(props) {
    super();

    uniqueId.enableUniqueIds(CReactQuill);

    this.state = {
      buttonLabel: '',
      buttonModalOpen: false,
      buttonPosition: 'left',
      buttonUrl: '',
      isImageUploading: false,
      savedRange: null
    };

    this.quillRef = null;
    this.lastKnownRange = null;
    const self = this;

    this.modules = {
      toolbar: {
        container: `#${CReactQuill.nextUniqueId()}`,
        handlers: {
          cmsButton() {
            const range = this.quill.getSelection(true);
            self.setState({
              buttonLabel: '',
              buttonModalOpen: true,
              buttonPosition: 'left',
              buttonUrl: '',
              savedRange: range || self.lastKnownRange
            });
          },
          customWhiteSpace: insertWhiteSpace,
          image() {
            self.imageUploads?.chooseImage();
          },
          test
        }
      }
    };
    this.props = props;

    this.handleChange = debounce(this.handleChange.bind(this), 150);
  }

  componentDidMount() {
    if (this.quillRef) {
      const quill = this.quillRef.getEditor();
      this.editor = quill;
      quill.on('selection-change', this.handleSelectionChange);

      this.imageUploads = attachImageUploads(quill, {
        onError: (message) => {
          this.handleChange.flush();
          const { notify } = this.context;
          notify({ message, severity: 'error' });
        },
        onUploadingChange: (isImageUploading) => {
          this.handleChange.flush();
          this.setState({ isImageUploading });
        }
      });
    }
  }

  componentWillUnmount() {
    this.imageUploads?.dispose();
    this.editor?.off('selection-change', this.handleSelectionChange);
    this.handleChange.cancel();
  }

  handleSelectionChange = (range) => {
    if (range) {
      this.lastKnownRange = range;
    }
  };

  handleChange = (value, delta, source, editor) => {
    const { onChange } = this.props;

    onChange(value, delta, source, editor);
  };

  confirmButtonInsert = () => {
    const { buttonLabel, buttonPosition, buttonUrl, savedRange } = this.state;
    if (this.quillRef && savedRange !== null) {
      const quill = this.quillRef.getEditor();
      const { index } = savedRange;
      quill.insertText(index, ' ');
      quill.insertEmbed(index, 'cmsButton', {
        label: buttonLabel || 'Button',
        position: buttonPosition || 'left',
        url: buttonUrl || '#'
      });
      quill.deleteText(index + 1, 1);
      const alignValue = buttonPosition === 'left' ? false : buttonPosition;
      quill.formatLine(index, 1, 'align', alignValue);
      quill.setSelection(index + 1);
    }
    this.setState({
      buttonLabel: '',
      buttonModalOpen: false,
      buttonPosition: 'left',
      buttonUrl: '',
      savedRange: null
    });
  };

  cancelButtonInsert = () => {
    this.setState({
      buttonLabel: '',
      buttonModalOpen: false,
      buttonPosition: 'left',
      buttonUrl: '',
      savedRange: null
    });
  };

  render() {
    const {
      buttonLabel,
      buttonModalOpen,
      buttonPosition,
      buttonUrl,
      isImageUploading
    } = this.state;

    return (
      <div className="text-editor">
        <div id={`${CReactQuill.lastUniqueId()}`}>
          <span className="ql-formats">
            <select className="ql-header" defaultValue="">
              <option value="1">Heading 1</option>
              <option value="2">Heading 2</option>
              <option value="3">Heading 3</option>
              <option value="4">Heading 4</option>
              <option value="">Paragraph</option>
            </select>
          </span>
          <span className="ql-formats">
            <button className="ql-bold" />
            <button className="ql-italic" />
            <button className="ql-underline" />
            <button className="ql-strike" />
          </span>
          <span className="ql-formats">
            <button className="ql-list" value="ordered" />
            <button className="ql-list" value="bullet" />
            <button className="ql-indent" value="-1" />
            <button className="ql-indent" value="+1" />
          </span>
          <span className="ql-formats">
            <button className="ql-script" value="super" />
            <button className="ql-script" value="sub" />
            <button className="ql-blockquote" />
            <button className="ql-direction" />
          </span>
          <span className="ql-formats">
            <select className="ql-color">
              <option value="red" />
              <option value="green" />
              <option value="blue" />
              <option value="orange" />
              <option value="violet" />
              <option value="#d0d1d2" />
              <option value="#F37021" />
              <option value="#808285" />
              <option value="#27AAE1" />
              <option value="#160F3E" />
              <option value="#FFFFFF" />
              <option value="#CBCCCC" />
              <option value="#6DCFF6" />
              <option value="#363373" />
              <option value="#F04E23" />
              <option value="#000000" />
              <option selected />
            </select>
            <select className="ql-background">
              <option value="red" />
              <option value="green" />
              <option value="blue" />
              <option value="orange" />
              <option value="violet" />
              <option value="#d0d1d2" />
              <option value="#F37021" />
              <option value="#808285" />
              <option value="#27AAE1" />
              <option value="#160F3E" />
              <option value="#FFFFFF" />
              <option value="#CBCCCC" />
              <option value="#6DCFF6" />
              <option value="#363373" />
              <option value="#F04E23" />
              <option value="#000000" />
              <option selected />
            </select>
          </span>
          <span className="ql-formats">
            <button className="ql-link" />
            <button className="ql-image" />
            <button className="ql-video" />
          </span>
          <span className="ql-formats">
            <button className="ql-formula" />
            <button className="ql-code-block" />
            <button className="ql-clean" />
          </span>
          <button className="ql-customWhiteSpace">
            <WhiteSpaceTag />
          </button>
          <button className="ql-cmsButton" title="Insert Button">
            <ButtonInsertTag />
          </button>
        </div>
        <ReactQuill
          ref={(el) => {
            this.quillRef = el;
          }}
          modules={this.modules}
          {...this.props}
          onChange={this.handleChange}
          theme="snow"
        />

        <Dialog
          fullWidth
          maxWidth="xs"
          open={isImageUploading}
          PaperProps={{
            style: {
              borderRadius: 20
            }
          }}
        >
          <DialogTitle style={{ padding: '28px 24px 16px', textAlign: 'center' }}>
            <span
              style={{
                fontFamily: 'Poppins, sans-serif',
                fontWeight: 600
              }}
            >
              Uploading image
            </span>
          </DialogTitle>

          <DialogContent style={{ padding: '0 28px 28px', textAlign: 'center' }}>
            <div
              style={{
                background: '#F0F4FF',
                borderRadius: '50%',
                height: 64,
                margin: '0 auto 18px',
                width: 64
              }}
            >
              <Loader size={28} />
            </div>

            <p style={{ color: '#6B7280', fontSize: 13, lineHeight: 1.7, margin: 0 }}>
              Please wait for your image to finish uploading.
            </p>
          </DialogContent>
        </Dialog>

        {buttonModalOpen && (
          <Modal
            footerActions={
              <>
                <CButton onClick={this.cancelButtonInsert} type="secondary">
                  Cancel
                </CButton>
                <CButton onClick={this.confirmButtonInsert} type="primary">
                  Insert
                </CButton>
              </>
            }
            handleClose={this.cancelButtonInsert}
            isModalOpen={buttonModalOpen}
            titleContent={<span className="modal-title">Insert Button</span>}
          >
            <div
              style={{ display: 'flex', flexDirection: 'column', gap: '16px', paddingTop: '8px' }}
            >
              <input
                onChange={(e) => this.setState({ buttonLabel: e.target.value })}
                placeholder="Button Label"
                style={buttonModalInputStyle}
                type="text"
                value={buttonLabel}
              />
              <input
                onChange={(e) => this.setState({ buttonUrl: e.target.value })}
                placeholder="Redirect URL"
                style={buttonModalInputStyle}
                type="text"
                value={buttonUrl}
              />
              <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                <label
                  style={{
                    color: '#6b7280',
                    fontFamily: 'Poppins',
                    fontSize: '12px',
                    fontWeight: 500
                  }}
                >
                  Button Position
                </label>
                <select
                  onChange={(e) => this.setState({ buttonPosition: e.target.value })}
                  style={{ ...buttonModalInputStyle, cursor: 'pointer' }}
                  value={buttonPosition}
                >
                  <option value="left">Left</option>
                  <option value="center">Center</option>
                  <option value="right">Right</option>
                </select>
              </div>
            </div>
          </Modal>
        )}
      </div>
    );
  }
}

CReactQuill.contextType = NotificationsContext;

export default CReactQuill;
